import { PARTIES, type FlipEntry } from '../lib/types';

interface Props {
  flips: FlipEntry[];
}

function timeAgo(ms: number): string {
  const sec = Math.max(0, Math.floor((Date.now() - ms) / 1000));
  if (sec < 60) return `${sec}s sedan`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min} min sedan`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} tim sedan`;
  const d = Math.floor(h / 24);
  return `${d} dagar sedan`;
}

export function RecentFlips({ flips }: Props) {
  if (!flips.length) {
    return (
      <section className="section">
        <h2>Senaste erövringar</h2>
        <p className="empty-state">Inga erövringar ännu. Bli den första!</p>
      </section>
    );
  }

  return (
    <section className="section">
      <h2>Senaste erövringar</h2>
      {flips.slice(0, 10).map((flip, i) => (
        <div className="flip-item" key={`${flip.districtId}-${i}`}>
          <span
            className="color-dot"
            style={{ background: PARTIES[flip.toParty].color }}
            title={PARTIES[flip.toParty].name}
          />
          <span>
            <strong>{PARTIES[flip.toParty].name}</strong> tog{' '}
            <strong>{flip.districtName}</strong>
            {flip.fromParty ? ` från ${PARTIES[flip.fromParty].name}` : ''}
          </span>
          <span className="when">{timeAgo(flip.at.toMillis())}</span>
        </div>
      ))}
    </section>
  );
}
